import GenericoCargo from './GenericoCargo'

const GenericaAbono = props => (
  <GenericoCargo
    {...props}
    type={props.type || 'ingreso'}
    modalTitle='Vinculaciones de Abono'
    vinculacionApiType='ingreso'
    createModel='vinculo-generico-venta'
  />
)

export default GenericaAbono
